import { CloseOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import { handleLogout } from '../../../../utils'
import Menu from './menu'

const ResponsiveMenu = ({ profile, open, onClose }) => {
    return (
        <Drawer
            title={profile()}
            closable={false}
            extra={<Button shape="round" type="text" icon={<CloseOutlined />} onClick={onClose} />}
            open={open}
            placement="right"
            footer={
                <Button type="primary" danger block onClick={handleLogout}>
                    Logout
                </Button>
            }
            classNames={{
                body: 'p-1'
            }}
        >
            <Menu onMenuClick={onClose} />
        </Drawer>
    )
}

export default ResponsiveMenu